"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertExhaustiveSwitch = void 0;
/*
    This method might not look like much but it is meant to assert that a switch block is exhaustive
    in regards to what ever it is checking
    For example, a switch case over an enum is considered exhaustive if all enum values
    have matching cases in the switch block, using this method in the default case of the switch block
    will enforce it at compile-time since a value not covered by a case will fallthrough, TS will
    error since that value is not assignable to the 'never' type, causing a compile time error to appear
*/
function assertExhaustiveSwitch(value, error) {
    if (error) {
        throw error;
    }
    return value;
}
exports.assertExhaustiveSwitch = assertExhaustiveSwitch;
//# sourceMappingURL=assert-exhaustive-switch.js.map